export default {
    computed : {
        cartItems () {
            return this.$store.state.cart.items || [];
        },
        sum () {
            let total = 0;
            this.$store.state.cart.items.forEach(item => {
                total += item.sum;
            })
            return total;
        },
        orderBonusPercent () {
            return +this.$store.state.initData.orderBonusPercent || 0;
        },
        newBonusesCount () {
            return Math.ceil((this.sum - this.appliedBonusesCount) * (this.orderBonusPercent / 100));
        },
        appliedBonusesCount () {
            return +this.$store.state.initData.appliedBonusesCount || 0;
        },
    },
    methods : {
        remove (item) {
            this.processed = true;
            let data = new FormData;
            data.append('cartId', item.cartId);
            fetch('/ajax/v1/cart/remove/', {
                method : 'POST',
                body : data,
            })
            .then(() => {
                this.processed = false;
                this.$store.dispatch('loadCartData');
            });
        },
        updateItem (item = {}, field = 'quantity') {
            if (this.processed) {
                return;
            }
            clearTimeout(this.updateTimeout);
            this.updateTimeout = setTimeout(()=>{
                this.processed = true;
                let data = new FormData;
                data.append('cartId', item.cartId);
                data.append('field', field);
                data.append('value', item[field]);
                data.append('item', JSON.stringify(item));
                fetch('/ajax/v1/cart/change/', {
                    method : 'POST',
                    body : data,
                })
                .then(() => {
                    this.processed = false;
                    this.$store.dispatch('loadCartData');
                });
            },1000);
        },
    },
}
